import styled from 'styled-components';

export const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 90%;
  max-width: 300px;
  margin: 0 auto;
  ${Styles.desktop`
    height: auto;
    width: 100%;
    max-width: none;
    justify-content: center;
  `}
`;
